function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.38749 16.9007C5.17517 18.0228 6.09809 19.3376 7.17783 20.9029C7.57508 21.4768 8.42488 21.4768 8.82217 20.9029C9.90191 19.3376 10.8248 18.0228 11.6125 16.9007C15.2413 11.731 16 10.6503 16 8C16 3.58171 12.4183 0 8 0C3.58171 0 0 3.58171 0 8C0 10.6503 0.758654 11.731 4.38749 16.9007ZM11.3333 8C11.3333 9.84096 9.84096 11.3333 8 11.3333C6.15904 11.3333 4.66667 9.84096 4.66667 8C4.66667 6.15904 6.15904 4.66667 8 4.66667C9.84096 4.66667 11.3333 6.15904 11.3333 8Z",
  fill: "#868E96"
});

var SvgMarkerGreyIcon = function SvgMarkerGreyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarkerGreyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker-grey-icon.1e3e9e57.svg";
export { ForwardRef as ReactComponent };